





























































































































































































































import { Component, Vue } from 'vue-property-decorator';
import { AgencyModule } from '@/store/modules/agency';
import { AppModule } from '@/store/modules/app';
import AgencyDetails from '@/components/Agencies/AgencyDetails.vue';
import AgencyAuthenticationEdit from '@/components/Agencies/AgencyAuthenticationEdit.vue';
import Alert from '@/components/Shared/Alert.vue';
import PageNames from '@/router/PageNames';
import GiganautVue from '@/components/Shared/GiganautVue'

@Component({
  name: 'Agency',
  components: { AgencyDetails, Alert, AgencyAuthenticationEdit }
})
export default class extends GiganautVue {

  async created() {
    await AgencyModule.getAgency(AppModule.currentAgencyContext.id);
  }

  get currentAgency() {
    return AgencyModule.currentAgency;
  }

  get loading() {
    return AgencyModule.loadingAgency;
  }

  getAuthProviderName(provider: number): string {
    switch(provider) {
      case 2: return 'Email/Password (Firebase)';
      case 3: return 'Microsoft Entra';
      case 4: return 'Google Workspace';
      default: return 'Email/Password (Firebase)';
    }
  }

  async navigateToAgencyList() {
    this.$router.push({ name: PageNames.SysAdminAgencies});
  }

  async switchToAgencyScope() {
    await AppModule.getAgencyContext(AgencyModule.currentAgency.id)
    await AppModule.getUserProfile()
    this.$router.push({ name: PageNames.AgencyDashboard});
  }
}
